<template>
<div>
  <div class="input-group input-group-sm">
    <multiselect :placeholder="`${title} filtern ...`" :options="items" v-model="filterCategories" :multiple="true" />
  </div>
  <b-btn class="btn btn-sm btn-block" style="margin-top: 2px;" @click="search(boxes)"> Anwenden </b-btn>
  <b-btn class="btn btn-sm btn-block" style="margin-top: 2px;" @click="deleteFilter(boxes)"> Filter zurücksetzen </b-btn>
</div>
</template>

<script>
import filterMixins from './filter-mixins'
import Multiselect from 'vue-multiselect'

export default {
  name: 'category-filter',
  mixins: [filterMixins],
  props: {
    boxes: Object
  },
  components: {
    Multiselect
  },
  data () {
    return {
      filterCategories: []
    }
  },
  computed: {
    searchedCategories () {
      var newCats = this.filterCategories.map(cat => cat.toLowerCase())
      return [...new Set(this.filterCategories.concat(newCats))]
    }
  },
  methods: {
    setOptions () {
      var setFilter = this.query.assocFilters[this.field]
      this.filterCategories = setFilter || []
    }
  },
  watch: {
    'query.assocFilters': {
      handler () {
        this.filterCategories = this.query.assocFilters[this.field] || []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/plugins/CategoryFilter.vue